import React from 'react'
import { Card, Form, Input, Button, Typography, message } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../store'
import { loginStart, loginSuccess, loginFailure } from '../store/slices/authSlice'
import { authService } from '../services/auth'
import { LoginForm } from '../types'

const { Title } = Typography

const Login: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { loading } = useSelector((state: RootState) => state.auth)
  
  const from = (location.state as any)?.from?.pathname || '/'

  const onFinish = async (values: LoginForm) => {
    try {
      dispatch(loginStart())
      
      const response = await authService.login(values)
      
      dispatch(loginSuccess(response))
      message.success('登录成功')
      
      // 跳转到之前访问的页面或首页
      navigate(from, { replace: true })
    } catch (error) {
      dispatch(loginFailure())
      // 错误消息已在api拦截器中处理
    }
  }

  return (
    <div className="flex-center" style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
        <div className="text-center mb-16">
          <Title level={2} style={{ color: '#1890ff', marginBottom: 8 }}>
            扫码装箱系统
          </Title>
          <Typography.Text type="secondary">
            请输入您的账号和密码登录
          </Typography.Text>
        </div>
        
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入用户名' },
              { min: 3, message: '用户名至少3个字符' }
            ]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="用户名" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6个字符' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="full-width"
              loading={loading}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
        
        <div className="text-center">
          <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
            扫码装箱系统 v1.0.0
          </Typography.Text>
        </div>
      </Card>
    </div>
  )
}

export default Login